import React from "react";

export default function PromotionalTabs({ activeTab, onTabChange, onTabClick }) {
  return (
    <div className="mb-4 bg-white rounded-xl shadow-md p-1 inline-flex flex-wrap gap-1">
      <button
        type="button"
        onClick={() => {
          onTabChange("specific");
          onTabClick?.();
        }}
        className={`px-4 sm:px-6 py-2 rounded-lg font-medium text-xs md:text-sm transition-all ${
          activeTab === "specific"
            ? "bg-red-500 text-white shadow-md"
            : "text-gray-600 hover:text-gray-800 hover:bg-gray-100"
        }`}>
        Send to Specific User
      </button>
      <button
        type="button"
        onClick={() => {
          onTabChange("all");
          onTabClick?.();
        }}
        className={`px-4 sm:px-6 py-2 rounded-lg font-medium text-xs md:text-sm transition-all ${
          activeTab === "all"
            ? "bg-red-500 text-white shadow-md"
            : "text-gray-600 hover:text-gray-800 hover:bg-gray-100"
        }`}>
        Send to All Users
      </button>
    </div>
  );
}
